import BaseMask from "./_base.mask";

const CPF_MASK = "SSS.SSS.SSS-SS";

const validateCPF = (cpf) => {
  if (cpf === "") {
    return true;
  }

  cpf = cpf.replace(/[^0-9a-zA-Z]+/gi, "");
  if (cpf.length !== 11) {
    return false;
  }

  if (!/^\d+$/.test(cpf)) {
    return true;
  }

  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rest = sum % 11;
  let digit1 = rest < 2 ? 0 : 11 - rest;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rest = sum % 11;
  let digit2 = rest < 2 ? 0 : 11 - rest;

  return (
    digit1 === parseInt(cpf.charAt(9)) && digit2 === parseInt(cpf.charAt(10))
  );
};

export class CpfMask extends BaseMask {
  static getType() {
    return "cpf";
  }

  getValue(value, settings) {
    return this.getVMasker().toPattern(value, CPF_MASK);
  }

  getRawValue(maskedValue, settings) {
    return maskedValue.replace(/[^0-9a-zA-Z]+/gi, "");
  }

  validate(value, settings) {
    return validateCPF(value);
  }
}
